const React = require('react');
const ClipboardText = require('../ClipboardText/A');
const CopyIcon = require('../../icons/Copy');
const toEllipsisMiddle = require('../../../utils/toEllipsisMiddle');


module.exports = ({name, value, ...props}) => {
  return (
    <div {...props}>
      {
        name ? (
          <div
            className="f18 fw5 ph20"
          >{name}</div>
        ) : null
      }
      <ClipboardText
        text={value}
        className="layoutRow fhaB fvaC bg0.1 r3 ph20 mt20 fw5 f14 lts.065em
          h56 ov"
      >
        <div>{value}</div>
        <CopyIcon className="w19 c0 o30"/>
      </ClipboardText>
    </div>
  );
};
